import {Button} from '@startlibs/components'
import { useNavigate } from '@startlibs/components';
import {will} from '@startlibs/utils'
import React from 'react'
import _ from 'lodash/fp'
import {
  CASE_ARCHIVED,
  CASE_CLOSED,
  CASE_DRAFT,
  PENDING_REQUEST,
  REQUEST_REJECTED
} from '../../enums/CaseState';
import {Header} from '../../components/Header'
import { InfoBox } from '../../components/InfoBox';
import {PageContainer, PageFooter} from '../../components/PageLayout'
import {PurviewFooter} from '../../components/PurviewFooter'
import {RequestOverview} from '../../request/RequestOverview'
import {useUnarchiveDialog} from '../hooks/useUnarchiveDialog'
import { ADMIN } from '../../enums/UserRoles'
import { getPredefinedReasonLabel } from '../../enums/PredefinedReason'

export const AdminRequestOverview = ({caseRequest,setCaseRequest}) => {
  const navigate = useNavigate()
  const unarchive = useUnarchiveDialog(caseRequest,_.flow(
    will(setCaseRequest,_.set("state", caseRequest?.whenAcceptedEpochMilli ? CASE_DRAFT : PENDING_REQUEST )),
    will(navigate,`/admin/request/${caseRequest.requestCode}`)
  ),false)

  const hasPredefinedReason = caseRequest?.caseInfo?.declinePredefinedReason ? true : false

  return <>
    <PageContainer>
        <Header title="Case overview">
          {
            (caseRequest.state === CASE_ARCHIVED || caseRequest.state === REQUEST_REJECTED) &&
          <Button highlight onClick={unarchive}>Unarchive case</Button>
          }
          {caseRequest.state === CASE_CLOSED &&
            <Button highlight onClick={() => navigate(`/admin/request/${caseRequest.requestCode}/report`)}>View final report</Button>
          }
        </Header>
        {caseRequest.state === CASE_ARCHIVED &&
          <InfoBox lightYellow css="margin-top: -1rem; margin-bottom: 2rem; padding:1.5rem">
            <p css="margin-bottom:0.25rem;"><b>This case was archived by an Administrator</b></p>
            <p css="margin-bottom:1.5rem;">If you need to continue this case, it can be unarchived.</p>
            {caseRequest?.caseInfo?.declineReason || caseRequest?.caseInfo?.declinePredefinedReason ? 
              <>
                <p css="margin-bottom:0.25rem;"><b>Reason given</b>
                {hasPredefinedReason ? <b>: {getPredefinedReasonLabel(caseRequest?.caseInfo?.declinePredefinedReason)}</b> : ''} 
                {caseRequest?.caseInfo?.declineReasonSharedPatient == false ? ' (not shared with patient)' : ''}
                {hasPredefinedReason ? '' : ':'}
                </p>
                <p css="margin-bottom:0.25rem;"> {caseRequest?.caseInfo?.declineReason} </p>
              </>
            :  
              <>
                <p css="margin-bottom:0.25rem;"><b>Archive reason: </b></p>
                <p css="margin-bottom:0;"> <i>No reason provided</i> </p>
              </>
            }
          </InfoBox>
        }
        <RequestOverview caseRequest={caseRequest} setCaseRequest={setCaseRequest} withClinicalSummary role={ADMIN}/>
        <PageFooter>
          {
            (caseRequest.state === CASE_ARCHIVED || caseRequest.state === REQUEST_REJECTED) &&
          <Button highlight onClick={unarchive}>Unarchive case</Button>
          }
          {caseRequest.state === CASE_CLOSED &&
            <Button highlight onClick={() => navigate(`/admin/request/${caseRequest.requestCode}/report`)}>View final report</Button>
          }
        </PageFooter>
    </PageContainer>
    <PurviewFooter/>
  </>
}
